import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { PatchMeProfileDTO } from "../../domain/contracts/employee-profile";
import { profileApi } from "./client";

export const profileKeys = {
  myProfile: ["me", "profile"] as const,
};

export function useMyProfileQuery() {
  return useQuery({
    queryKey: profileKeys.myProfile,
    queryFn: () => profileApi.getMyProfile(),
    staleTime: 60_000,
  });
}

export function usePatchMyProfileMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (dto: PatchMeProfileDTO) => profileApi.patchMyProfile(dto),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: profileKeys.myProfile });
    },
  });
}
